import { EvidenceServiceApiKey } from "@app/injectionKeys";
import { injectStrict } from "@app/utils/injectStrict";
import { Timeframe } from "@core/domain/types/timeframe.type";

export function useProcedurePresetAssistant() {
  const evidenceService = injectStrict(EvidenceServiceApiKey);

  async function findProcedureNames({
    procedureName,
  }: {
    procedureName: string;
  }): Promise<string[]> {
    const { data } = await evidenceService.api.assistantsControllerFindProcedureNames({
      procedureName,
    });
    return data;
  }

  async function generateLevelOfEvidence({
    procedureNames,
    purpose,
  }: {
    procedureNames: string;
    purpose: string;
  }) {
    const { data } =
      await evidenceService.api.assistantsControllerGenerateLevelOfEvidenceForProcedure({
        procedureNames,
        purpose,
      });
    return data;
  }

  async function determineTimeFrame({
    procedureNames,
    purpose,
  }: {
    procedureNames: string;
    purpose: string;
  }): Promise<Timeframe | undefined> {
    const { data } = await evidenceService.api.assistantsControllerDetermineTimeFrameForProcedure({
      procedureNames,
      purpose,
    });
    return data;
  }

  return {
    findProcedureNames,
    generateLevelOfEvidence,
    determineTimeFrame,
  };
}
